"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _validators = require("vuelidate/lib/validators");
var _validate = require("@/utils/validate");
var _utils = require("@/utils");
var _auth = require("@/utils/auth");
var _vuex = require("vuex");
var _constants = require("@/config/constants");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var validCPF = function validCPF(value) {
  return (0, _validate.validateCPF)(value);
};
var _default = exports.default = {
  name: 'UsersForm',
  bodyClass: 'users-new-update-form-page',
  components: {
    Card: _components.Card,
    AppInput: _components.AppInput,
    AppSelect: _components.AppSelect,
    TableListBusinessUnit: _components.TableListBusinessUnit
  },
  data: function data() {
    return {
      listBusinessUnitPersons: [],
      filePhoto: null,
      idUser: null,
      listStatus: [{
        id: true,
        name: 'Ativo'
      }, {
        id: false,
        name: 'Inativo'
      }],
      listTypes: _constants.LIST_TYPES_USERS,
      listBusinessUnits: [],
      clientBusinessUnit: null,
      userForm: {},
      form: {
        document: '',
        name: '',
        birthdate: '',
        phone: '',
        email: '',
        password: '',
        imageUrl: '',
        activated: 1,
        role: null
      }
    };
  },
  computed: {
    photoValid: function photoValid() {
      if ((0, _validate.validURL)(this.userForm.imageUrl)) return true;
      return false;
    },
    namePage: function namePage() {
      if (this.$route.name === 'ProfileUser') {
        return 'Perfil';
      }
      return 'Cadastro de usuário';
    },
    descriptionType: function descriptionType() {
      if (!this.form.role) return '';
      var type = this.resolveRoleOption(this.form.role);
      return type ? type.name : this.form.role;
    },
    user: function user() {
      return (0, _auth.getUser)().user;
    },
    isAdmin: function isAdmin() {
      return this.user.role === 'Admin' || this.user.role === 'TIHive';
    }
  },
  created: function created() {
    var id = this.$route.params.id;
    if (id) {
      this.idUser = id;
      this.getDetails();
    }
    if (this.$route.name === 'ProfileUser') {
      this.idUser = (0, _auth.getUser)().user.personId;
      this.getDetails();
    }
  },
  validations: function validations() {
    if (this.$route.name === 'ProfileUser') {
      return {
        form: {
          document: {
            required: _validators.required,
            validCPF: validCPF
          },
          name: {
            required: _validators.required,
            minLength: (0, _validators.minLength)(4)
          },
          birthdate: {},
          phone: {},
          email: {
            required: _validators.required,
            email: _validators.email
          },
          password: {},
          imageUrl: {},
          activated: {
            required: _validators.required
          },
          role: {}
        }
      };
    }
    return {
      form: {
        document: {
          required: _validators.required,
          validCPF: validCPF
        },
        name: {
          required: _validators.required,
          minLength: (0, _validators.minLength)(4)
        },
        birthdate: {},
        phone: {},
        email: {
          required: _validators.required,
          email: _validators.email
        },
        password: {
          required: _validators.required
        },
        imageUrl: {},
        activated: {
          required: _validators.required
        },
        role: {}
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchAllBusinessUnitPersons', 'fetchUserDetail', 'fetchBusinessUnits', 'updateUser', 'createUser', 'uploadToS3'])), {}, {
    resolveRoleOption: function resolveRoleOption(value) {
      if (!value) return null;
      return this.listTypes.find(function (item) {
        return item.idItem === value || item.name === value;
      }) || null;
    },
    normalizeRole: function normalizeRole(value) {
      var type = this.resolveRoleOption(value);
      return type ? type.idItem : value || null;
    },
    joinForms: function joinForms() {
      for (var _i = 0, _Object$entries = Object.entries(this.form); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 1),
          key = _Object$entries$_i[0];
        var value = this.userForm ? this.userForm[key] : null;
        if (key === 'birthdate') {
          this.form[key] = value ? (0, _utils.convertDateBR)(value) : '';
          continue;
        }
        if (key === 'role') {
          this.form[key] = this.normalizeRole(value);
          continue;
        }
        this.form[key] = value !== null && value !== void 0 ? value : null;
      }
    },
    getDetails: function () {
      var _getDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$this$fetchUser, data, _data$person;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.fetchUserDetail(this.idUser);
            case 1:
              _yield$this$fetchUser = _context.v;
              data = _yield$this$fetchUser.data;
              if (data) {
                this.userForm = _objectSpread(_objectSpread(_objectSpread({}, data), data.person), {}, {
                  role: this.normalizeRole(data.role || ((_data$person = data.person) === null || _data$person === void 0 ? void 0 : _data$person.role))
                });
                this.joinForms();
                this.getBusinessUnitPersons();
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getDetails() {
        return _getDetails.apply(this, arguments);
      }
      return getDetails;
    }(),
    cancel: function cancel(e) {
      e.preventDefault();
      this.$v.$reset();
    },
    translateRole: function translateRole(value) {
      var type = this.resolveRoleOption(value);
      return type ? type.idItem : value;
    },
    saveData: function () {
      var _saveData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
        var payload, urlFileImage, action, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              e.preventDefault();
              this.$v.$touch();
              if (!this.$v.$invalid) {
                _context2.n = 1;
                break;
              }
              this.$buefy.toast.open({
                duration: 5000,
                message: "Por favor, verifique os campos <b>obrigat\xF3rios</b>!",
                position: 'is-top',
                type: 'is-danger'
              });
              _context2.n = 5;
              break;
            case 1:
              payload = _lodash.default.cloneDeep(this.form);
              if (!this.filePhoto) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return this.uploadFiles(this.filePhoto, 'png');
            case 2:
              urlFileImage = _context2.v;
              if (urlFileImage) {
                payload.imageUrl = urlFileImage;
              }
            case 3:
              if (payload.birthdate) {
                payload.birthdate = (0, _utils.convertDate)(payload.birthdate);
              }
              action = this.createUser;
              if (this.idUser) {
                action = this.updateUser;
                payload.idUser = this.idUser;
                delete payload.password;
              }
              payload.role = this.translateRole(payload.role);
              _context2.n = 4;
              return action(payload);
            case 4:
              data = _context2.v;
              if (data) {
                this.$buefy.toast.open({
                  message: 'Dados salvos com sucesso!',
                  type: 'is-success',
                  duration: 6000
                });
                if (!this.idUser) {
                  this.$router.push({
                    name: 'UsersList'
                  });
                }
              }
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function saveData(_x) {
        return _saveData.apply(this, arguments);
      }
      return saveData;
    }(),
    uploadFiles: function () {
      var _uploadFiles = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(file, type) {
        var self;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              self = this;
              return _context4.a(2, new Promise(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(resolve, reject) {
                  var data, resp;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.n) {
                      case 0:
                        data = {
                          image: file,
                          typeFile: type || ''
                        };
                        _context3.n = 1;
                        return self.uploadToS3(data);
                      case 1:
                        resp = _context3.v;
                        if (resp) resolve(resp);else reject();
                      case 2:
                        return _context3.a(2);
                    }
                  }, _callee3);
                }));
                return function (_x4, _x5) {
                  return _ref.apply(this, arguments);
                };
              }()));
          }
        }, _callee4, this);
      }));
      function uploadFiles(_x2, _x3) {
        return _uploadFiles.apply(this, arguments);
      }
      return uploadFiles;
    }(),
    openModalPass: function openModalPass() {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalFormPassword,
        hasModalCard: true,
        customClass: 'modal-form-change-pass-user',
        trapFocus: true,
        canCancel: ['escape', 'outside'],
        props: {
          idUser: this.idUser
        }
      });
    },
    confirmDeleteBusinessUnitPersons: function confirmDeleteBusinessUnitPersons(item) {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalWarning,
        hasModalCard: true,
        trapFocus: true,
        props: {
          text: 'Deseja realmente exluir',
          action: this.deleteItemBusinessUnitPersons,
          name: item.Name,
          idItem: item.BusinessUnitPersonId
        }
      });
    },
    deleteItemBusinessUnitPersons: function () {
      var _deleteItemBusinessUnitPersons = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id) {
        var data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.deleteBusinessUnitPersons(id);
            case 1:
              data = _context5.v;
              if (data) this.getBusinessUnitPersons();
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function deleteItemBusinessUnitPersons(_x6) {
        return _deleteItemBusinessUnitPersons.apply(this, arguments);
      }
      return deleteItemBusinessUnitPersons;
    }(),
    getBusinessUnitPersons: function () {
      var _getBusinessUnitPersons = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return this.fetchAllBusinessUnitPersons(this.idUser);
            case 1:
              data = _context6.v;
              if (data) {
                this.listBusinessUnitPersons = _lodash.default.orderBy(data, ['OrganizationName', 'BusinessUnitName']);
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function getBusinessUnitPersons() {
        return _getBusinessUnitPersons.apply(this, arguments);
      }
      return getBusinessUnitPersons;
    }()
  })
};